const fields = [
  {
    dataIndex: 'patentName',
    key: 'patentName',
    title: '名称',
    scopedSlots: {
      customRender: 'TextAction'
    }
  },
  {
    dataIndex: 'operationTypeStr',
    key: 'operationType',
    title: '运营类型'
  },
  {
    dataIndex: 'priceRange',
    key: 'priceRange',
    title: '价格',
    customRender(text) {
      return text === -1 ? '面议' : `￥${text}`
    }
  },
  {
    dataIndex: 'publishTime',
    key: 'publishTime',
    title: '发布日期',
    width: 120
  },
  {
    dataIndex: 'createTime',
    key: 'createTime',
    title: '创建日期',
    width: 120
  },
  {
    title: '操作',
    key: 'action',
    fixed: 'right',
    scopedSlots: {
      customRender: 'action'
    }
  }
]

const formRow = [
  {
    span: 7,
    label: '名称',
    component: 'AInput',
    placeholder: '请输入需求名称',
    prop: 'patentName',
    allowClear: true
  },
  {
    span: 7,
    label: '运营类型',
    component: 'ASelect',
    prop: 'operationType',
    placeholder: '选择运营类型',
    allowClear: true,
    list: [
      { label: '待转化', value: '0' },
      { label: '许可', value: '1' },
      { label: '质押', value: '2' },
      { label: '转让', value: '3' }
    ]
  },
  {
    span: 7,
    label: '创建日期',
    component: 'ASelect',
    prop: 'searchValue',
    placeholder: '选择创建日期',
    list: [
      { label: '全部日期', value: '0' },
      { label: '近一个月', value: '1' },
      { label: '近三个月', value: '2' },
      { label: '近半年', value: '3' },
      { label: '近一年', value: '4' }
    ]
  }
]

const slotOpt = [
  {
    slot: 'TextAction',
    component: 'TextAction',
    cb: 'toDetail'
  },
  {
    slot: 'action',
    component: 'Action',
    list: [{ name: '删除', cb: 'delete' }]
  }
]

module.exports = {
  fields,
  slotOpt,
  formRow
}
